const mod = require('../bahabot.module.js')

/**
 * @param {angular.resource.IResourceService} $resource
 * @returns {TaggedMessagesService}
 */
function bahabotTaggedMessagesFactory($resource) {
    const TaggedMessages = $resource('/api/protected/tagged-messages/', {}, {
        get: { method: 'GET' },
    });

    const self = {};

    self.filters = {
        dateFrom: "",
        dateTo: "",
        cursor: "",
    }

    self.totalCount = 0;
    self.lastFilters = null;
    self.data = null;

    self.loading = false;
    self.loadingMore = false;

    self.validateDates = () => {
        let from = self.filters.dateFrom ? new Date(self.filters.dateFrom) : null;
        let to = self.filters.dateTo ? new Date(self.filters.dateTo) : null;

        if (from && isNaN(from.getTime())) {
            from = null;
        }
        if (to && isNaN(to.getTime())) {
            to = null;
        }

        if (from && to && from > to) {
            const temp = from;
            from = to;
            to = temp;
        }

        self.filters.dateFrom = from ? from.toISOString() : "";
        self.filters.dateTo = to ? to.toISOString() : "";
    };

    self.get = () => {
        self.validateDates();
        self.loading = true;
        return TaggedMessages
            .get(self.filters)
            .$promise
            .then(res => {
                self.data = res.data;
                self.lastFilters = { ...self.filters };
                self.lastFilters.cursor = res.data.pageInfo.endCursor;
                self.totalCount = res.data.pageInfo.totalCount;
                return res.data;
            })
            .finally(() => {
                self.loading = false;
            });
    };

    self.next = () => {
        self.loadingMore = true;
        return TaggedMessages
            .get(self.lastFilters)
            .$promise
            .then(res => {
                self.data.items = [...self.data.items, ...res.data.items];
                self.data.pageInfo = res.data.pageInfo;
                self.lastFilters.cursor = res.data.pageInfo.endCursor;
                return self.data;
            })
            .finally(() => {
                self.loadingMore = false;
            });
    }

    self.resetFilters = () => {
        self.filters.dateFrom = "";
        self.filters.dateTo = "";
        self.filters.cursor = "";
        return self;
    };

    function escapeCSV(value) {
        if (value == null) return '';
        const str = String(value);
        if (/["\n,]/.test(str)) {
            return `"${str.replace(/"/g, '""')}"`;
        }
        return str;
    }


    self.toCSV = () => {
        if (!self.data.items || !self.data.items.length) return;

        const headers = ['id', 'message', 'tag', 'confirmed', 'createdAt', 'confirmedAt'];

        const rows = [
            headers.join(','),
            ...self.data.items.map(row =>
                headers.map(field => escapeCSV(row[field])).join(',')
            )
        ];

        const csvContent = rows.join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'export.csv';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    return self;
}

mod.factory('TaggedMessagesService', ["$resource", bahabotTaggedMessagesFactory]);
